import { CSLReference, CSLReferenceMeta } from '../../../../../../libs/cite/src/types';
import { Reference } from '../reference.model';

/**
 * Resolves the UI source class used to render source badges for references.
 */
export const getReferenceSourceClass = (
  reference: Pick<Reference, 'csl'>,
): CSLReferenceMeta['source'] | undefined => {
  return (reference?.csl as CSLReference | undefined)?._meta?.source;
};

/**
 * Whether the reference has been marked as reviewed (e.g. AI or plain-text sourced). Reads from csl._meta.reviewed.
 */
export const getReferenceReviewed = (reference: Pick<Reference, 'csl'>): boolean => {
  return (reference?.csl as CSLReference | undefined)?._meta?.reviewed === true;
};
